/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    console.log(response)

    const offcanvasCart = document.querySelector('#offcanvas-cart')

    offcanvasCart?.classList.add('loading')

    const newResponse = await fetch(window.location.href)
    const text = await newResponse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))

    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
        badge.removeAttribute('hidden')
    })

    offcanvasCart?.classList.remove('loading')

    window.dispatchEvent(new Event('updated.ecomify.cart'))

    if (response.ok) {
        if (response.url.includes('add.js')) {
            // offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')

            // const data = await response.json()

            // if (data.items?.length > 1) {
            //     const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')

            //     elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
            //     elemAlertItemsAdded.removeAttribute('hidden')
            // } else {
            //     offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')
            //         .removeAttribute('hidden')
            // }
        } else {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
        }
    } else {
        const data = await response.json()
        const alert = document.querySelector('#offcanvas-cart-alert-error')
        alert.querySelector('span').textContent = `${data.message} - ${data.description}`
        alert.removeAttribute('hidden')
    }

    if (offcanvasCart?.querySelector('#offcanvas-cart-empty')) {
        setTimeout(() => {
            bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart).hide()
        }, 500)
    }

    if (document.querySelector('.cart-goal-completed')) {
        if (!document.querySelector('#cart-goal').textContent.toLowerCase().includes('gift card')) return

        if (!document.querySelector('.product-item-e-gift-card')) {
            setTimeout(() => {
                window.refreshCartContents()
            }, 2000)
        }
    } else {
        document.querySelector('.product-item-e-gift-card button[data-remove-line-item]')?.click()
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    if (btn.dataset.isGiftBoxParent === 'true') {
        const updates = {}

        console.log(btn.closest('.product-item'))

        btn.closest('.product-item').querySelectorAll('.list-item-child-product-item').forEach(elem => {
            console.log(elem)
            updates[elem.dataset.lineItemKey] = 0
        })

        console.log(updates)

        await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        })
    }

    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Cart note - Show button on keydown
window.showNoteButton = (input) => {
    input.closest('#cart-note').querySelector('button').removeAttribute('hidden')
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click
// window.onClickCheckoutBtn = (btn) => {
//     btn.style.height = btn.clientHeight + 'px'
//     btn.innerHTML = `
//         <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
//             <span class="visually-hidden">Loading...</span>
//         </div>
//     `
// }

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoal()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const modal = document.querySelector('#shipping-rates-modal')

    modal.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    modal.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    modal.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = modal.querySelector('#shipping-rates-modal-country').value
    const province = modal.querySelector('#shipping-rates-modal-province').value
    const zip = modal.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })
    console.log(prepareResponse)

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
        console.log(asyncRespose)

        const data = await asyncRespose.json()
        console.log(data)

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            modal.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            modal.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            modal.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${modal.dataset.textNoResults}
                </p>
            `
            modal.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()
        console.log(data)

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        modal.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        modal.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

/*
    Delivery Info
*/
window.onClickCartDeliveryCollapse = (btn, event) => {
    setTimeout(() => {
        const container = document.querySelector('.rebuy-cart__flyout-content')
        container.scroll({ top: container.scrollHeight, behavior: 'smooth' })
    }, 250)
}

window.openCartNoteModal = (btn, event) => {
    document.querySelector('#cart-note-modal').classList.add('show')
}

window.openCartDateModal = (btn, event) => {
    document.querySelector('#cart-date-modal').classList.add('show')
}

window.closeCartModal = (btn, event) => {
    btn.closest('.cart-delivery-modal').classList.remove('show')
}

const initCartCalender = () => {
    // eslint-disable-next-line no-new
    new AirDatepicker('#cart-delivery-info-calendar', {
        locale: {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear'
        },
        inline: true,
        dateFormat: 'MM/dd/yyyy',
        timeFormat: 'hh:mm aa',
        firstDay: 0,
        minDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000),

        onRenderCell ({ date, cellType }) {
            if (cellType === 'day') {
                return {
                    disabled: date.getDay() === 6 || date.getDay() === 0
                }
            }
        },
        async onSelect (date, formattedDate, picker) {
            console.log(date.date)
            // console.log(date.formattedDate)
            // localStorage.setItem('delivery-date', date.formattedDate)

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: {
                        delivery: date.formattedDate
                    }
                })
            })

            document.querySelector('#btn-cart-date-modal').innerHTML = `Change date <span>(${date.formattedDate})</span>`

            document.querySelector('#cart-date-modal')?.classList.remove('show')
        }
    })
}
initCartCalender()

window.addEventListener('updated.ecomify.cart', () => {
    initCartCalender()
})

window.savePersonalizationNote = async (btn, event) => {
    event.preventDefault()

    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const wrapper = btn.closest('.gift-note-wrapper')

    const to = wrapper.querySelector('[name="attributes[To]"]')
    const from = wrapper.querySelector('[name="attributes[From]"]')
    const message = wrapper.querySelector('[name="attributes[Message]"]')

    const attributes = {
        to: to.value,
        from: from.value,
        message: message.value
    }

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes
        })
    })

    if (attributes.to || attributes.from || attributes.from) {
        document.querySelector('#btn-cart-note-modal').textContent = 'Edit note details'
    }

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.text
        document.querySelector('#cart-note-modal')?.classList.remove('show')
    }, 2000)
}

window.populateGitNoteFields = () => {
    const myInterval = setInterval(() => {
        document.querySelectorAll('.gift-note-wrapper').forEach(async (wrapper) => {
            const response = await fetch('/cart.json')
            const data = await response.json()

            const to = wrapper.querySelector('[name="attributes[To]"]')
            const from = wrapper.querySelector('[name="attributes[From]"]')
            const message = wrapper.querySelector('[name="attributes[Message]"]')

            to.value = data.attributes.to ?? ''
            from.value = data.attributes.from ?? ''
            message.value = data.attributes.message ?? ''

            if (data.attributes.to || data.attributes.from || data.attributes.from) {
                document.querySelector('#btn-cart-note-modal').textContent = 'Edit note details'
            }

            if (data.attributes.delivery) {
                document.querySelector('#btn-cart-date-modal').innerHTML = `Change date <span>(${data.attributes.delivery})</span>`
            }

            clearInterval(myInterval)
        })
    }, 2000)
}
window.populateGitNoteFields()

// // Fix a small buy in the Rebuy Cart Drawer on opening
// document.addEventListener('rebuy:smartcart.show', (event) => {
//     console.log(event)
//     document.querySelectorAll('.rebuy-cart__flyout').forEach(elem => {
//         elem.style.position = 'static'
//         setTimeout(() => {
//             elem.style.position = 'fixed'
//         }, 200)
//     })
// })

// Tier Progress bars
const initTierProgressBars = () => {
    document.querySelectorAll('.tier-progress-bar').forEach(progressBar => {
        const now = Number(progressBar.getAttribute('aria-valuenow'))
        const min = Number(progressBar.getAttribute('aria-valuemin'))
        const max = Number(progressBar.getAttribute('aria-valuemax'))

        if (now < min) {
            progressBar.style.width = '0%'
        } else {
            progressBar.style.width = now / max * 100 + '%'
        }

        const progressLabel = progressBar.closest('.progress').nextElementSibling

        if (now >= max) {
            progressLabel.classList.add('progress-label-completed')
        } else {
            progressLabel.classList.remove('progress-label-completed')
        }
    })
}
initTierProgressBars()

window.addEventListener('updated.ecomify.cart', async () => {
    const res = await fetch('/cart.json')
    const data = await res.json()

    document.querySelectorAll('.tier-progress-bar').forEach(progressBar => {
        progressBar.setAttribute('aria-valuenow', data.total_price)
    })
    initTierProgressBars()
})

if (window.location.href.includes('cart=true')) {
    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }
}

//giftcard app 
window.addEventListener("govalo:productAddedToCart", function() {
    window.refreshCartContents()
    if (document.querySelector('#offcanvas-cart')) {
        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    }
});